export function getInitialTreeState(orgTree) {
  const data = orgTree ? updateFromOrgTree({}, orgTree) : {};

  if (orgTree) {
    data[orgTree.depthId] = { depthId: orgTree.depthId, isOpen: true };
  }

  return {
    data,
    lastAction: null,
  };
}

function newNode(node) {
  return {
    depthId: node.depthId,
    isOpen: false,
  };
}

function reduceOrgNode(data, source, node) {
  const entry = source[node.depthId] ?? newNode(node);
  data[node.depthId] = entry;

  node.children.forEach((child) => {
    reduceOrgNode(data, source, child);
  });

  return data;
}

export function updateFromOrgTree(data, orgTree) {
  if (!orgTree) {
    return data;
  }

  return reduceOrgNode({ ...data }, data, orgTree);
}

function toggleNode(data, itemId) {
  const node = data[itemId];

  if (!node) {
    return data;
  }

  return {
    ...data,
    [itemId]: {
      ...node,
      isOpen: !node.isOpen,
    },
  };
}

function setNodeOpen(data, itemId, isOpen) {
  const node = data[itemId];

  if (!node || node.isOpen === isOpen) {
    return data;
  }

  return {
    ...data,
    [itemId]: {
      ...node,
      isOpen,
    },
  };
}

function dataReducer(data, action) {
  switch (action.type) {
    case 'toggle':
      return toggleNode(data, action.itemId);

    case 'expand':
      return setNodeOpen(data, action.itemId, true);

    case 'collapse':
      return setNodeOpen(data, action.itemId, false);

    case 'refresh':
      return updateFromOrgTree(data, action.orgTree);

    default:
      return data;
  }
}

export function treeStateReducer(state, action) {
  return {
    data: dataReducer(state.data, action),
    lastAction: action,
  };
}

export function findItem(state, itemId) {
  return state.data[itemId];
}
